const reduceArrayToObject = arr =>
  arr.reduce((obj, item) => {
    const itemData = Object.entries(item)[0]
    return { ...obj, [itemData[0]]: itemData[1] }
  }, {})

export default reduceArrayToObject
